import { render, staticRenderFns } from "./OpenBankingDetails.vue?vue&type=template&id=20d799be&scoped=true"
import script from "./OpenBankingDetails.vue?vue&type=script&lang=js"
export * from "./OpenBankingDetails.vue?vue&type=script&lang=js"
import style0 from "./OpenBankingDetails.vue?vue&type=style&index=0&id=20d799be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d799be",
  null
  
)

export default component.exports